import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/conector-light")({
  head: () => ({
    meta: [
      { title: "Conector Bizaclia — Encuentra tu local con IA" },
      {
        name: "description",
        content:
          "El conector inteligente de Bizaclia te hace las preguntas necesarias para encontrar el local que necesitas en solo 1 minuto.",
      },
      { property: "og:title", content: "Conector Bizaclia — Encuentra tu local con IA" },
      {
        property: "og:description",
        content:
          "Responde unas preguntas rápidas y nuestro algoritmo de IA te ayudará a encontrar el local perfecto.",
      },
    ],
  }),
  component: () => <Outlet />,
});
